<template>
  <div>
    <Slidercomponent :lista="listaprops" />
  </div>
</template>

<script>
import Slidercomponent from "@/components/Slidercomponent.vue";

export default {
  name: "Atran",
  components: {
    Slidercomponent
  },
  data() {
    return {
      listaprops: [
        {
          id: 0,
          rubrik: "Ätran",
          text: "En dold del av Halland",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-atran/Atran1.jpg"
        },
        {
          id: 1,
          rubrik: "Ätran",
          text: "De vild öringarnas land",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-atran/Atran2.jpg"
        },
        {
          id: 2,
          rubrik: "Ätran",
          text: "Skygg fisk",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-atran/Atran3.jpg"
        },
        {
          id: 3,
          rubrik: "Ätran",
          text: "I kanten av huvudfåran",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-atran/Atran4.jpg"
        },
        {
          id: 4,
          rubrik: "Ätran",
          text: "Många ståndplatser.",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-atran/Atran5.jpg"
        },
        {
          id: 5,
          rubrik: "Ätran",
          text: "De hugger på nymfer.",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-atran/Atran6.jpg"
        },
        {
          id: 6,
          rubrik: "Ätran",
          text: "Hullinglöst",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-atran/Atran7.jpg"
        },
        {
          id: 7,
          rubrik: "Ätran",
          text: "Försiktiga vak",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-atran/Atran8.jpg"
        },
        {
          id: 8,
          rubrik: "Ätran",
          text: "Catch and release",
          imglink:
            "https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-atran/Atran9.jpg"
        }
      ]
    };
  }
};
</script>
